const API_BASE_URL = "https://api.pathpalz.com/api";

const API_BASE_URL_GEOCODE = "https://nominatim.openstreetmap.org/search";

export default {
  baseUrl: API_BASE_URL,
  baseUrlGeocode: API_BASE_URL_GEOCODE,
};
